import { message } from "antd";

export async function openCashDrawer(serverUrl?: string): Promise<boolean> {
  try {
    const baseUrl = serverUrl || "http://localhost:9100";
    const drawerKickCmd = [0x1b, 0x70, 0x00];

    const res = await fetch(`${baseUrl}/api/print`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        printerName: "",
        data: drawerKickCmd,
      }),
    });

    if (!res.ok) {
      console.warn("Cash drawer command sent but printer returned an error.");
      return false;
    }
    return true;
  } catch {
    console.warn("Could not reach the local printer server to open cash drawer.");
    return false;
  }
}
